import api from "@/services/api"
import type { CreateUpdateOrderResponse } from "../sharedTypes/orders"

export type CreateOrderParams = {
  orderItems: {
    productId: string | null
    productModifierIds: string[] | null
    price: number | null
    note: string | null
  }[]
  amountGratuity?: number
  isOpen?: boolean
  isCollection?: boolean
  tableId?: string | null
  note?: string | null
  customerName?: string | null
  customerPhone?: string | null
  collectionAt?: string | null
  serviceChargePercentage?: number | null
  serviceChargeFlat?: number | null
}

export const createOrder = async (
  params: CreateOrderParams
) => {
  const { body } =
    await api.post<CreateUpdateOrderResponse>(`/orders/`, {
      body: params,
    })
  return body
}
